import {
  DEPRECATED_backwardsCompatibleValues,
  StrictLocalizeFunction,
} from "@faire/web/common/localization/localize";
import { Button } from "@faire/web/slate/Button";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";

export const getBestsellersCategoryHeaderText = (
  highestPrecisionCategoryName: string,
  strictLocalize: StrictLocalizeFunction
) => {
  return strictLocalize(
    {
      defaultMessage: "Bestsellers in {categoryCollectionName}",
      description: {
        text: "Header of a page showing the best-selling products in a category, e.g. Bestsellers in Home Decor",
      },
    },
    {
      categoryCollectionName: highestPrecisionCategoryName,
    }
  );
};

export const getSaleCategoryHeaderText = (
  highestPrecisionCategoryName: string,
  strictLocalize: StrictLocalizeFunction
) => {
  return strictLocalize(
    {
      defaultMessage: "Sale {categoryCollectionName}",
      description: {
        text: "Header of a page showing the best-selling products in a category, e.g. Sale in Home Decor",
        img: "https://cdn.faire.com/fastly/b7b2813a8f64dabbbb5836f15425df7b076ff5d2909a44dd74422f6063bfcb0c.png",
      },
    },
    {
      categoryCollectionName: highestPrecisionCategoryName.toLowerCase(),
    }
  );
};

export const getEcoFriendlyCategoryHeaderText = (
  ecoFriendlyCategoryDisplayName: string,
  parentCategoryName?: string
) => {
  if (parentCategoryName === undefined) {
    return ecoFriendlyCategoryDisplayName;
  }
  return parentCategoryName + " | " + ecoFriendlyCategoryDisplayName;
};

export const getShowroomCategoryHeaderText = (
  showroomCategoryDisplayName: string,
  parentCategoryName?: string
) => {
  if (parentCategoryName === undefined) {
    return showroomCategoryDisplayName;
  }
  return parentCategoryName + " | " + showroomCategoryDisplayName;
};

export const getNewBrandsCategorySubheaderText = (
  highestPrecisionCategory: string,
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize(
    {
      defaultMessage: "Shop our newest brands in {highestPrecisionCategory}",
      description: {
        text: "message telling retailer to look at new brands from a specific category",
      },
    },
    DEPRECATED_backwardsCompatibleValues({
      highestPrecisionCategory,
    })
  );

export const getNewProductsCategorySubheaderText = (
  highestPrecisionCategory: string,
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize(
    {
      defaultMessage: "Shop our fresh new finds in {highestPrecisionCategory}",
      description: {
        text: "message telling retailer to look at new products from a specific category",
      },
    },
    DEPRECATED_backwardsCompatibleValues({ highestPrecisionCategory })
  );

export const getInsiderEarlyAccessSubheaderText = (
  isNonAmericanInsider: boolean,
  helpCenterLink: string
) => {
  if (isNonAmericanInsider) {
    return (
      <StrictLocalMsg
        defaultMessage="Discover the newest brands on Faire 48 hours before the rest of the marketplace."
        description={{
          text: "[subtitle] description for early access of new brands for insiders",
        }}
      />
    );
  } else {
    return (
      <>
        <Spacer size="1x" />
        <Typography>
          <StrictLocalMsg
            defaultMessage="Shop the newest brands to join Faire. <LinkFormatting>Learn More</LinkFormatting>"
            description={{
              text: "Insider Early Access, Category, Subheader",
              img: "https://cdn.faire.com/fastly/95b2eaffbdb9b84ca39524ec0a569d157b4a0c3dbc60fa8fc65de8d279640edf.png",
            }}
            values={{
              LinkFormatting: (chunk) => LinkFormmatting(chunk, helpCenterLink),
            }}
          />
        </Typography>
      </>
    );
  }
};

const LinkFormmatting = (chunk: React.ReactNode, helpCenterLink: string) => (
  <Button variant="tertiary" linkTo={helpCenterLink} target="_blank">
    {chunk}
  </Button>
);
